import { formatUserFacingError } from '@/lib/errors'
import { useEffect, useState } from 'react'
import { servicesService } from '../services/services.service'
import type { ServiceDocument, ServiceCategoryDocument } from '@/types'

interface UseServicesResult {
  services: Array<ServiceDocument & { id: string }>
  categories: Array<ServiceCategoryDocument & { id: string }>
  loading: boolean
  error: string | null
}

export function useServices(): UseServicesResult {
  const [services, setServices] = useState<Array<ServiceDocument & { id: string }>>([])
  const [categories, setCategories] = useState<Array<ServiceCategoryDocument & { id: string }>>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    setLoading(true)
    setError(null)
    Promise.all([servicesService.getPublishedServices(), servicesService.getCategories()])
      .then(([svcs, cats]) => {
        setServices(svcs)
        setCategories(cats)
      })
      .catch((err: unknown) =>
        setError(formatUserFacingError(err, 'Failed to load services'))
      )
      .finally(() => setLoading(false))
  }, [])

  return { services, categories, loading, error }
}
